export default __webpack_public_path__ + "static/media/FI.6ade0c4c.svg";